import { NavLink, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import BoardPage from './pages/BoardPage';
import ItemPage from './pages/ItemPage';
import SearchPage from './pages/SearchPage';
import PageView from './pages/PageView';
import LoginPage from './pages/LoginPage';
import ReportPage from './pages/ReportPage';
import MilestonesPage from './pages/MilestonesPage';
import MyWorkPage from './pages/MyWorkPage';

export default function App() {
  const { session, email, role, loading, error, signOut } = useAuth();
  const { pathname } = useLocation();
  // A board wants every pixel; prose wants a readable line length.
  const wide = pathname === '/' || pathname.startsWith('/milestones');

  if (!session) return <LoginPage />;
  if (loading && !role) return <p className="loading" style={{ padding: 40 }}>Signing in...</p>;

  return (
    <>
      <header className="topbar">
        <span className="brand">
          <img src="/icon.svg" alt="" />
          Reality Tracker
        </span>
        <nav className="nav">
          <NavLink to="/" end>
            Board
          </NavLink>
          <NavLink to="/me">My work</NavLink>
          <NavLink to="/milestones">Milestones</NavLink>
          <NavLink to="/kb">Knowledge</NavLink>
          <NavLink to="/report">Report</NavLink>
        </nav>
        <span className="whoami">
          {email}
          {role === 'reporter' ? ' (reporter)' : ''}
          <button className="ghost" style={{ marginLeft: 12, padding: '4px 10px' }} onClick={signOut}>
            Sign out
          </button>
        </span>
      </header>
      <main className={wide ? 'wide' : undefined}>
        {error ? <div className="error">{error}</div> : null}
        <Routes>
          <Route path="/" element={<BoardPage />} />
          <Route path="/item/:key" element={<ItemPage />} />
          <Route path="/me" element={<MyWorkPage />} />
          <Route path="/milestones" element={<MilestonesPage />} />
          <Route path="/kb" element={<SearchPage />} />
          <Route path="/kb/*" element={<PageView />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="*" element={<p className="empty">Nothing here.</p>} />
        </Routes>
      </main>
    </>
  );
}
